module.exports = __webpack_public_path__ + "img/access-google_bg.e0900c44.png";